import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { FaBars, FaTimes } from 'react-icons/fa'
import './NavbarStyles.css'
import logo from '../assets/logo.png'

const Navbar = () => {
    const [click, setClick] = useState(false)
    const handleClick = () => setClick(!click)

    const [color, setColor] = useState(false)
    const changeColor = () => {
        if (window.scrollY >= 100) {
            setColor(true)
        } else {
            setColor(false)
        }
    }

    window.addEventListener('scroll', changeColor)

    return (
        <div className={color ? 'header header-bg' : 'header'}>
            <Link to='/'><img src={logo} alt="Logo" width='100px' height='auto' /></Link>
            <ul className={click ? 'nav-menu active' : 'nav-menu'}>
                <li>
                    <Link to='/'>Home</Link>
                </li>
                <li>
                    <Link to='/training'>About Us</Link>
                </li>
                <li className="dropdown">
                    <Link to='/pricing'>Entries</Link>
                    <div className="dropdown-content">
                        <Link to='/general-delegate'>General Delegate</Link>
                        <Link to='/mine-owner'>Mine Owner</Link>
                        <Link to='/investor'>Investor</Link>
                        <Link to='/machinery-supplier'>Machinery Supplier</Link>
                        <Link to='/commodity-direct-buyer'>Commodity Direct Buyer</Link>
                        <Link to='/direct-smelter'>Direct Smelter</Link>
                    </div>
                </li>
                <li>
                    <Link to='/contact'>Venue</Link>
                </li>
                <li>
                    <Link to='/csi'>CSI</Link>
                </li>
                <li>
                    <Link to='/sponsor'>
                        <button className='btn-sponsor'>Sponsor</button>
                    </Link>
                </li>
            </ul>
            <div className='hamburger' onClick={handleClick}>
                {click ? (<FaTimes size={20} style={{ color: '#fff' }} />) : (<FaBars size={20} style={{ color: '#fff' }} />)}
            </div>
        </div>
    )
}

export default Navbar
